import React, { memo, forwardRef } from "react";
const SvgAlphabetT = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M18.74 22.12c-.347.173-.74.26-1.18.26-.64 0-1.16-.087-1.56-.26a2.402 2.402 0 01-.94-.74 3.044 3.044 0 01-.48-1.08 6.94 6.94 0 01-.12-1.32V14.5h-.78c-.227 0-.413-.033-.56-.1a1.009 1.009 0 01-.32-.24.902.902 0 01-.16-.32 1.43 1.43 0 01-.04-.3c0-.08.013-.173.04-.28a.732.732 0 01.16-.3.888.888 0 01.32-.26c.147-.08.333-.12.56-.12h.78v-1.66c0-.28.04-.5.12-.66.093-.173.2-.307.32-.4a.905.905 0 01.38-.18c.133-.04.253-.06.36-.06.093 0 .207.02.34.06.147.027.28.087.4.18s.22.227.3.4c.093.16.14.38.14.66v1.66h1.5c.227 0 .407.04.54.12.147.067.26.153.34.26.08.093.133.193.16.3.027.107.04.2.04.28 0 .08-.013.18-.04.3a.902.902 0 01-.16.32.966.966 0 01-.34.24c-.133.067-.313.1-.54.1h-1.5v4.46c0 .96.307 1.44.92 1.44h.18l.2-.04c.08-.013.133-.02.16-.02h.12c.307 0 .533.093.68.28a.93.93 0 01.24.62c0 .4-.193.693-.58.88z"
      />
    </svg>
  );
});
SvgAlphabetT.displayName = "SvgAlphabetT";
const MemoForwardRef = memo(SvgAlphabetT);
export default MemoForwardRef;
